import type { CSSProperties, FC, ReactNode } from "react";
import type { EChartsOption } from "echarts";
import EChart from "@/pages/CampaignOverviewPage/components/EChart";

interface ChartStateBodyProps {
  error: string | null;
  errorMessage: string;
  isEmpty: boolean;
  isLoading: boolean;
  loadingClassName: string;
  messageClassName: string;
  noDataMessage: string;
  // Children replace the default EChart for DOM-rendered charts (e.g. the
  // video funnel) while keeping the shared error/loading/empty states.
  children?: ReactNode;
  option?: EChartsOption;
  style?: CSSProperties;
}

const ChartStateBody: FC<ChartStateBodyProps> = ({
  children,
  error,
  errorMessage,
  isEmpty,
  isLoading,
  loadingClassName,
  messageClassName,
  noDataMessage,
  option,
  style,
}) => {
  if (error) {
    return <p className={messageClassName}>{errorMessage}</p>;
  }
  if (isLoading) {
    return <div aria-busy="true" className={loadingClassName} role="status" />;
  }
  if (isEmpty) {
    return <p className={messageClassName}>{noDataMessage}</p>;
  }
  if (children) {
    return children;
  }
  return option ? <EChart option={option} style={style} /> : null;
};

export default ChartStateBody;
